const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/app/summary',
    authenticatedEntryPathAdminExpert: '/app/summary',
    authenticatedEntryPathStandard: '/app/summary',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/account/kyc-form',
    enableMock: true
}

export default appConfig